/* Back in Stock auf der Produktkachel (DREA-6).
 *
 * WOZU: Auf der Kategorieseite steht bei ausverkauften Produkten der Knopf
 * "Benachrichtigen". Bis 09.10.2026 fuehrte der nur auf die Produktseite, weil
 * Klaviyos eigenes Onsite-Formular dort nicht zu gebrauchen ist: es bindet
 * seinen Klick-Handler ausschliesslich an Elemente, die beim Laden der Seite
 * schon im Dokument stehen, kennt keine Auffrisch-Funktion und ist laut Klaviyo
 * fuer Produktseiten gedacht. Auf einer Kachel-Liste scheitert es deshalb.
 *
 * WIE: Wir umgehen das Onsite-Formular und sprechen Klaviyos oeffentlichen
 * Client-Endpunkt direkt an. Der ist genau dafuer gebaut - er authentifiziert
 * sich nur ueber die oeffentliche Site-ID (steht ohnehin im Quelltext), nimmt
 * also keinen privaten Schluessel entgegen. Ein privater Schluessel darf hier
 * auch nie stehen: alles im Theme ist oeffentlich lesbar.
 *
 *   POST https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=<ID>
 *   Header: revision: 2024-10-15
 *   Varianten-Id im Format  $shopify:::$default:::<SHOPIFY_VARIANT_ID>
 *   Antwort 202 = angenommen
 *
 * BELEGT am 09.10.2026 im Klaviyo-Konto von D4K:
 * - Flow U2LwkB "Back in Stock Flow INV (NEU)" ist live und haengt an der
 *   Metrik "Subscribed to Back in Stock" (XNtv8J).
 * - Dort laufen laufend echte Anmeldungen ein, angereichert mit ProductID,
 *   VariantId, SKU und Preis. Das Format oben stammt aus so einem Ereignis.
 * - Der Flow wartet mit BACK_IN_STOCK_DELAY auf inventory_min 5. Heisst:
 *   die Mail geht erst raus, wenn der Artikel mit mindestens 5 Stueck zurueck
 *   ist. Bewusst so belassen (Entscheidung Fabian, 09.10.2026) - wer hier also
 *   testet und keine Mail bekommt, hat nicht zwingend einen Fehler gefunden.
 *
 * AUFBAU: Ein einziger Dialog fuer die ganze Seite, erst beim ersten Klick
 * gebaut. Die Kacheln selbst tragen nur ihre Varianten-Id und die Texte.
 */

(function () {
  if (window.lbrgtBisClpAktiv) return;
  window.lbrgtBisClpAktiv = true;

  var REVISION = '2024-10-15';
  var dialog = null;
  var felder = {};
  var aktiveKarte = null;

  /* Die Site-ID steht im Klaviyo-Skript, das die App einbindet. Bewusst von
     dort gelesen statt fest verdrahtet: wechselt das Konto, wandert die Id
     automatisch mit.
     ⚠️ Klaviyo laedt rund ein Dutzend Skripte von derselben Adresse
     (runtime, vendors~..., signup_forms ...). Nur eines davon traegt die Id.
     Deshalb ALLE durchgehen - das erste zu nehmen geht schief. */
  function firmenId() {
    var skripte = document.querySelectorAll('script[src*="klaviyo.com/onsite/js/"]');
    for (var i = 0; i < skripte.length; i++) {
      var quelle = skripte[i].src || '';
      var treffer =
        quelle.match(/[?&]company_id=([A-Za-z0-9]+)/) || quelle.match(/\/onsite\/js\/([A-Za-z0-9]+)\/klaviyo\.js/);
      if (treffer) return treffer[1];
    }
    console.warn('[lbrgt-bis] Keine Klaviyo-Site-ID im Seitenquelltext gefunden.');
    return null;
  }

  /* Alle Beschriftungen kommen in EINEM Attribut von der Kachel (data-bis-texte,
     als JSON aus den Sprachdateien). Einzeln waeren das vierzehn Attribute pro
     Kachel - und auf einer Kategorieseite koennen mehrere ausverkaufte Kacheln
     stehen. */
  function texte(karte) {
    if (!karte) return {};
    if (!karte._lbrgtTexte) {
      try {
        karte._lbrgtTexte = JSON.parse(karte.dataset.bisTexte || '{}');
      } catch (fehler) {
        karte._lbrgtTexte = {};
      }
    }
    return karte._lbrgtTexte;
  }

  function text(karte, name, ersatz) {
    return texte(karte)[name] || ersatz;
  }

  function dialogBauen(karte) {
    dialog = document.createElement('dialog');
    dialog.className = 'lbrgt-bis-dialog';
    dialog.innerHTML = [
      '<button type="button" class="lbrgt-bis-dialog__zu" data-zu aria-label="',
      text(karte, 'schliessen', 'Schließen'),
      '">&times;</button>',
      '<p class="lbrgt-bis-dialog__produkt" data-produkt></p>',
      '<h2 class="lbrgt-bis-dialog__titel" data-titel></h2>',
      '<p class="lbrgt-bis-dialog__text" data-einleitung></p>',
      '<form class="lbrgt-bis-dialog__form" data-form novalidate>',
      '  <div class="lbrgt-bis-dialog__variante" hidden data-variantezeile>',
      '    <label class="lbrgt-bis-dialog__label" for="lbrgt-bis-variante" data-variantelabel></label>',
      '    <select class="lbrgt-bis-dialog__feld" id="lbrgt-bis-variante" data-variante></select>',
      '  </div>',
      '  <label class="lbrgt-bis-dialog__label" for="lbrgt-bis-email" data-emaillabel></label>',
      '  <input class="lbrgt-bis-dialog__feld" id="lbrgt-bis-email" type="email" name="email" autocomplete="email" required data-email>',
      '  <label class="lbrgt-bis-dialog__marketing" hidden data-marketingzeile>',
      '    <input type="checkbox" data-marketing>',
      '    <span data-marketingtext></span>',
      '  </label>',
      '  <button type="submit" class="btn btn--primary lbrgt-bis-dialog__senden" data-senden></button>',
      '  <p class="lbrgt-bis-dialog__hinweis" data-hinweis></p>',
      '</form>',
      '<p class="lbrgt-bis-dialog__meldung" role="status" aria-live="polite" data-meldung></p>',
    ].join('');

    document.body.appendChild(dialog);

    felder = {
      produkt: dialog.querySelector('[data-produkt]'),
      titel: dialog.querySelector('[data-titel]'),
      einleitung: dialog.querySelector('[data-einleitung]'),
      emailLabel: dialog.querySelector('[data-emaillabel]'),
      varianteZeile: dialog.querySelector('[data-variantezeile]'),
      varianteLabel: dialog.querySelector('[data-variantelabel]'),
      variante: dialog.querySelector('[data-variante]'),
      email: dialog.querySelector('[data-email]'),
      marketingZeile: dialog.querySelector('[data-marketingzeile]'),
      marketing: dialog.querySelector('[data-marketing]'),
      marketingText: dialog.querySelector('[data-marketingtext]'),
      senden: dialog.querySelector('[data-senden]'),
      hinweis: dialog.querySelector('[data-hinweis]'),
      meldung: dialog.querySelector('[data-meldung]'),
      form: dialog.querySelector('[data-form]'),
    };

    dialog.querySelector('[data-zu]').addEventListener('click', function () {
      dialog.close();
    });
    felder.form.addEventListener('submit', absenden);
  }

  /* Mehrvariantige Produkte: Auswahl anbieten. Ohne sie traegt der Knopf
     stumm die erste Variante ein und der Kunde wird auf die falsche Farbe
     oder Groesse benachrichtigt. Einvariantige Produkte sehen die Zeile nie. */
  function variantenFuellen(karte) {
    var liste = [];
    try {
      liste = JSON.parse(karte.dataset.bisVarianten || '[]');
    } catch (fehler) {
      liste = [];
    }

    if (!Array.isArray(liste) || liste.length < 2) {
      felder.varianteZeile.hidden = true;
      felder.variante.innerHTML = '';
      return;
    }

    felder.varianteLabel.textContent = text(karte, 'varianteLabel', 'Variante');
    felder.variante.innerHTML = '';
    liste.forEach(function (v) {
      var option = document.createElement('option');
      option.value = String(v.id);
      option.textContent = v.titel;
      felder.variante.appendChild(option);
    });
    felder.variante.value = karte.dataset.bisVariante || String(liste[0].id);
    felder.varianteZeile.hidden = false;
  }

  function oeffnen(karte) {
    aktiveKarte = karte;
    if (!dialog) dialogBauen(karte);

    felder.produkt.textContent = karte.dataset.bisProdukt || '';
    felder.titel.textContent = text(karte, 'titel', 'Benachrichtigung bei Verfügbarkeit');
    felder.einleitung.textContent = text(karte, 'einleitung', '');
    felder.emailLabel.textContent = text(karte, 'emailLabel', 'E-Mail-Adresse');
    variantenFuellen(karte);
    felder.senden.textContent = text(karte, 'absenden', 'Benachrichtigen');
    // Enthaelt bewusst HTML (Link auf die Datenschutzerklaerung) und stammt aus
    // der Sprachdatei des Themes, nicht aus einer Eingabe.
    felder.hinweis.innerHTML = text(karte, 'hinweis', '');

    var liste = karte.dataset.bisListe;
    felder.marketingZeile.hidden = !liste;
    felder.marketing.checked = false;
    felder.marketingText.textContent = text(karte, 'marketing', '');

    felder.form.hidden = false;
    felder.meldung.textContent = '';
    felder.meldung.className = 'lbrgt-bis-dialog__meldung';
    felder.email.value = '';
    felder.senden.disabled = false;

    dialog.showModal();
    felder.email.focus();
  }

  function meldung(art, inhalt) {
    felder.meldung.textContent = inhalt;
    felder.meldung.className = 'lbrgt-bis-dialog__meldung lbrgt-bis-dialog__meldung--' + art;
  }

  function anmelden(id, variante, email) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(id), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variante } },
          },
        },
      }),
    });
  }

  /* Getrennter Aufruf, mit Absicht. Die Benachrichtigung ist eine einmalige
     Service-Nachricht, der Newsletter ist Werbung - das sind zwei
     Einwilligungen. Die Liste traegt in Klaviyo das Double-Opt-in, die
     Bestaetigungsmail kommt also von dort. */
  function newsletter(id, listenId, email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(id), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: listenId } } },
        },
      }),
    });
  }

  async function absenden(ereignis) {
    ereignis.preventDefault();
    var karte = aktiveKarte;
    var email = felder.email.value.trim();

    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      meldung('fehler', text(karte, 'emailFehler', 'Bitte eine gültige E-Mail-Adresse eingeben.'));
      felder.email.focus();
      return;
    }

    var id = firmenId();
    var variante = felder.varianteZeile.hidden ? karte.dataset.bisVariante : felder.variante.value;
    if (!id || !variante) {
      meldung('fehler', text(karte, 'fehler', 'Das hat nicht geklappt. Bitte später noch einmal versuchen.'));
      return;
    }

    felder.senden.disabled = true;
    meldung('warte', text(karte, 'senden', 'Wird gesendet …'));

    try {
      var antwort = await anmelden(id, variante, email);
      if (!antwort.ok) throw new Error('HTTP ' + antwort.status);

      if (felder.marketing.checked && karte.dataset.bisListe) {
        // Scheitert der Newsletter, bleibt die Benachrichtigung trotzdem gueltig.
        try {
          await newsletter(id, karte.dataset.bisListe, email);
        } catch (fehler) {
          console.warn('[lbrgt-bis] Newsletter-Anmeldung fehlgeschlagen', fehler);
        }
      }

      felder.form.hidden = true;
      meldung('ok', text(karte, 'ok', 'Passt. Wir melden uns, sobald der Artikel wieder da ist.'));
    } catch (fehler) {
      console.warn('[lbrgt-bis] Anmeldung fehlgeschlagen', fehler);
      felder.senden.disabled = false;
      meldung('fehler', text(karte, 'fehler', 'Das hat nicht geklappt. Bitte später noch einmal versuchen.'));
    }
  }

  document.addEventListener('click', function (ereignis) {
    var knopf = ereignis.target.closest && ereignis.target.closest('[data-lbrgt-bis-knopf]');
    if (!knopf) return;
    var karte = knopf.closest('[data-bis-variante]');
    if (!karte) return;
    ereignis.preventDefault();
    oeffnen(karte);
  });
})();
